<template>
  <div class="app-container">
    <div class="top_btns clearfix">
      <div class="left_box">
        <!-- <el-date-picker @change="getList()" v-model="listQuery.period" type="month" value-format="YYYYMM" size="mini" placeholder="日期" style="width: 160px;margin-right:5px;"></el-date-picker> -->
        <qzf-search-period v-model:period="listQuery.period" @success="init()"></qzf-search-period>
        <!-- <el-select v-model="listQuery.comId" placeholder="请选择公司" size="mini" style="width:200px" @change="getList" filterable>
          <el-option
            v-for="item in optionList"
            :key="item.value"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
        <el-button class="filter-item1" type="primary" size="mini" plain @click="handleFilter" style="margin-left:10px">搜索</el-button>
        <div class="total_box" style="display:inline-block">
          (<span>销项数量:{{1}} </span>
          <span>销项金额:{{2}} </span>
          <span>销项税额:{{3}} </span>
          <span>销项价税合计:{{4}} </span>)
        </div>
      </div>
      <div class="right_box">

      </div>
    </div>
    <div>
      <el-row>
        <el-col :span="19" style="position: relative;">
          <div class="status">
            <div v-if="listQuery.comId != 0 && comInfo.shStatus == 2">
              <img src="@/assets/shtg.png">
            </div>
            <!-- 审核未通过 -->
            <div v-else-if="listQuery.comId != 0">
              <img src="@/assets/wsh.png">
            </div>
          </div>
          <el-table stripe :data="list" :height="contentStyleObj" style="width: 98%" border size="mini" show-summary v-if="this.list.length != 0">
            <el-table-column prop="name" label="申报列表名称" min-width="320">
              <template #default="scope">
                <span>{{$tableNameFilter(scope.row.tableName)}}</span>
                <span style="margin-left:10px;color:#39b0d2;cursor:pointer" @click="declareDetail(scope.row)">申报详情</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="取数状态" align="center" min-width="90">
              <!-- <template #default="scope">
                <span>{{scope.row.statusTax}}</span>
              </template> -->
              <div class="item_icon">
                <i class="el-icon-success"></i>
                <p>已取数</p>
              </div>
            </el-table-column>
            <!-- <el-table-column prop="name" label="计提状态" align="center" min-width="120">
              <div class="item_icon">
                <i class="el-icon-success"></i>
                <p>已计提</p>
              </div>
            </el-table-column> -->
            <el-table-column label="申报状态" align="center" min-width="100">
              <template #default="scope">
                <el-tooltip placement="top" :disabled="scope.row.errLog == ''" v-if="scope.row.taskStatus">
                  <template #content> {{scope.row.errLog}} </template>
                  <div class="item_icon" v-if="scope.row.taskStatus == '0'">
                    <i class="el-icon-warning"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '1'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '2'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '3'">
                    <i class="el-icon-success"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '4'">
                    <i class="el-icon-error"></i>
                    <p style="color:red">{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '5'">
                    <!-- <i class="el-icon-info"></i> -->
                    <el-button :loading="true" type="text">{{ $setUpStatusSb(scope.row.taskStatus) }}</el-button>
                    <!-- <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p> -->
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '6'">
                    <i class="el-icon-success"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="应补退税额" align="center" min-width="70">
              <template #default="scope">
                <span>{{scope.row.sf}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="开始时间" min-width="120" align="center">
              <template #default="scope">
                <span>{{scope.row.beginAt}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="结束时间" min-width="120" align="center">
              <template #default="scope">
                <span>{{scope.row.endAt}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" label="扣款状态" align="center" min-width="100">
              <template #default="scope">
                <el-tooltip placement="top" :disabled="scope.row.errLog2 == ''" v-if="scope.row.taskStatus2">
                  <template #content> {{scope.row.errLog2}} </template>
                  <div class="item_icon" v-if="scope.row.taskStatus2 == '0'">
                    <i class="el-icon-warning"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '1'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '2'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '3'">
                    <i class="el-icon-success"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '4'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '5'">
                    <i class="el-icon-error"></i>
                    <p style="color:red">{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="开始时间" min-width="100" align="center">
              <template #default="scope">
                <span>{{scope.row.beginAt2}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="结束时间" min-width="100" align="center">
              <template #default="scope">
                <span>{{scope.row.endAt2}}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="tax" label="税款" align="center" min-width="80">
              <template #default="scope">
                <span>{{scope.row.tax}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" label="税款" align="center" min-width="70">
              <template #default="scope">
                <span>{{scope.row.sf}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="年税负率" align="center" min-width="80">
              <template #default="scope">
                <span>{{scope.row.sfYear}}</span>
              </template>
            </el-table-column> -->
          </el-table>
          <el-table stripe :data="gsList" :height="contentStyleObj" style="width: 98%;margin-top:20px" border size="mini" show-summary v-if="this.gsList.length != 0">
            <!-- <el-table-column prop="name" label="申报表生成时间" min-width="160" align="center">
              <template #default="scope">
                <span>{{$parseTime(scope.row.createdAt,'{y}-{m}-{d} {h}:{i}:{s}')}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" label="薪酬信息" min-width="320">
              <template #default="scope">
                <span>{{$tableNameFilter(scope.row.tableName)}}</span>
                <span style="margin-left:10px;color:#39b0d2;cursor:pointer" @click="declareDetail(scope.row)">申报详情</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="申报人数" align="center" min-width="70">
              <template #default="scope">
                <span>{{scope.row.sf}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="工资/收入" align="center" min-width="70">
              <template #default="scope">
                <span>{{scope.row.sf}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="个税金额" align="center" min-width="70">
              <template #default="scope">
                <span>{{scope.row.sf}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="计提状态" align="center" min-width="120">
              <div class="item_icon">
                <i class="el-icon-success"></i>
                <p>已计提</p>
              </div>
            </el-table-column> -->
            <el-table-column label="申报状态" align="center" min-width="100">
              <template #default="scope">
                <el-tooltip placement="top" :disabled="scope.row.errLog == ''" v-if="scope.row.taskStatus">
                  <template #content> {{scope.row.errLog}} </template>
                  <div class="item_icon" v-if="scope.row.taskStatus == '0'">
                    <i class="el-icon-warning"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '1'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '2'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '3'">
                    <i class="el-icon-success"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '4'">
                    <i class="el-icon-error"></i>
                    <p style="color:red">{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '5'">
                    <!-- <i class="el-icon-info"></i> -->
                    <el-button :loading="true" type="text">{{ $setUpStatusSb(scope.row.taskStatus) }}</el-button>
                    <!-- <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p> -->
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus == '6'">
                    <i class="el-icon-success"></i>
                    <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="开始时间" min-width="120" align="center">
              <template #default="scope">
                <span>{{scope.row.beginAt}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="结束时间" min-width="120" align="center">
              <template #default="scope">
                <span>{{scope.row.endAt}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" label="扣款状态" align="center" min-width="100">
              <template #default="scope">
                <el-tooltip placement="top" :disabled="scope.row.errLog2 == ''" v-if="scope.row.taskStatus2">
                  <template #content> {{scope.row.errLog2}} </template>
                  <div class="item_icon" v-if="scope.row.taskStatus2 == '0'">
                    <i class="el-icon-warning"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '1'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '2'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '3'">
                    <i class="el-icon-success"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '4'">
                    <i class="el-icon-info"></i>
                    <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                  <div class="item_icon" v-else-if="scope.row.taskStatus2 == '5'">
                    <i class="el-icon-error"></i>
                    <p style="color:red">{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="查看明细" align="center" min-width="70">
              <template #default="scope">
                <el-button size="mini" @click="check(scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="name" label="开始时间" min-width="100" align="center">
              <template #default="scope">
                <span>{{scope.row.beginAt2}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="结束时间" min-width="100" align="center">
              <template #default="scope">
                <span>{{scope.row.endAt2}}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="tax" label="税款" align="center" min-width="80">
              <template #default="scope">
                <span>{{scope.row.tax}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="税负率" align="center" min-width="70">
              <template #default="scope">
                <span>{{scope.row.sf}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="年税负率" align="center" min-width="80">
              <template #default="scope">
                <span>{{scope.row.sfYear}}</span>
              </template>
            </el-table-column> -->
          </el-table>
        </el-col>
        <el-col :span="5">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" style="height:100%">
            <el-tab-pane label="全部新增客户" name="first"></el-tab-pane>
            <el-tab-pane label="已审核" name="second"></el-tab-pane>
            <el-tab-pane label="未审核" name="third"></el-tab-pane>
          <div class="top_search">
            <el-input size="mini" style="width: 240px;" v-model="initList.name"></el-input>
            <el-button type="primary" size="mini" plain @click="init" style="margin-left:10px">搜索</el-button>
          </div>
          <div class="center_main" :style="{height: contentStyleRight}">
            <div
              v-for="(item,index) in data"
              :key="index"
              @click="getList(item.id)" :class="{curs:this.listQuery.comId == item.id}"
            >{{item.name}}</div>
          </div>
          </el-tabs>
        </el-col>
      </el-row>
      
    </div>
    <div style="margin-top:20px">
      <el-button v-if="listQuery.comId && comInfo.shStatus == 2" size="mini" type="danger" @click="shenHe(9)" plain>反审核</el-button>
      <el-button v-else-if="listQuery.comId" size="mini" type="danger" @click="shenHe(2)" plain>审核</el-button>
    </div>
  </div>

  <declareDetails ref="declareDetails"></declareDetails>
</template>

<script>
import { taxList } from "@/api/taxCalculation"
import { eaCompanyList, toExamine } from "@/api/company"
import { currentAccountPeriod } from '@/utils'
import declareDetails from "./components/declareDetails"
export default {
  name: "taxStatistics",
  components:{
    declareDetails
  },
  data(){
    return{
      comInfo: {
        shStatus: 0,
      },
      listQuery:{
        period:currentAccountPeriod(),
        comId:'',
      },
      initList:{
        status:'2',
        shStatus: 0,
        name: ''
      },
      optionList:[],
      list:[],
      gsList:[],
      data:[],
      activeName: 'first',
      sh_status: true
    }
  },
  created(){
    this.init()
    this.contentStyleObj= this.$getHeight(600)
    this.contentStyleRight=this.$getHeight(412)
  },
  methods:{
    init(){
      this.initList.period = this.listQuery.period
      eaCompanyList(this.initList).then(res=>{
        this.data = res.data.data.list
        this.getList()
      })
    },
    getList(id){
      if(id){
        this.listQuery.comId = Number(id)
      }else {
        this.listQuery.comId = 0
      }
      let comInfos = this.data.filter(v=>{
        return id == v.id
      })
      if(comInfos.length != 0){
        this.comInfo = comInfos[0]
      }
      taxList(this.listQuery).then(res=>{
        if(res.data.data.list){
          this.list =  res.data.data.list.filter(v=>{
            return v.tableName != "gs_gs" && v.tableName != "gs_gs_one"
          })
          this.gsList =  res.data.data.list.filter(v=>{
            return v.tableName == "gs_gs" || v.tableName == "gs_gs_one"
          })
        }else{
          this.list = []
          this.gsList = []
        }
      })
    },
    getSummaries(param){
      let { columns, data } = param;
      let taxTotal = 0
      let vatFjsTotal = 0
      let sumTotal = 0
      data = this.list
      data.map(v=>{
        taxTotal += v.tax
        if(v.vatFjs){
          vatFjsTotal += v.vatFjs
        }
        sumTotal = taxTotal + vatFjsTotal
      })
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }if(column.property == "tax"){
          if(sumTotal){
            sums[index] = sumTotal.toFixed(2)
          } else{
            sums[index] = 0
          }
        }else {
          sums[index] = '--';
        }
      });
      return sums;
    },
    declareDetail(e) {
      this.$refs.declareDetails.init(e.comId,this.listQuery.period,e.taskName)
    },
    handleClick(){
      this.comId = this.$options.data().comId
      if(this.activeName == "first"){
        this.initList.shStatus = 0
      }else if(this.activeName == "second"){
        this.initList.shStatus = 2
      }else if(this.activeName == "third"){
        this.initList.shStatus = 9
      }
      this.init()
    },
    // 审核
    shenHe(e) {
      this.comInfo.shStatus = e
      let param = {
        shStatus: this.comInfo.shStatus,
        period: this.listQuery.period,
        comId: this.listQuery.comId
      }
      toExamine(param).then(res => {
        if(res.data.msg == 'success') {
          this.$qzfMessage('成功',3)
          this.init()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.top_btns {
  margin-bottom: 10px;
   .left_box{
    float: left;
    width: 56%;
  }
  .right_box {
    float: right;
    text-align: right;
    .status {
      position: absolute;
      top: 20px;
      right: 360px;
    }
  }
}
.styleForm{
  .el-select{
    margin-left: 0px;
  }
}
.total_box{
  margin-left: 15px;
  p{
    display: inline-block;
    font-size: 15px;
    color: #333;
    line-height: 24px;
  }
  span{
    color: #666;
    font-size: 14px;
    line-height: 24px;
  }
}
.status{
  position: absolute;
  right: 0px;
  top:-30px;
  z-index: 99;
  img{
    width:100px;
  }
}
.item_icon{
  display: inline-block;
  cursor: pointer;
  i{
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
  }
  .el-icon-error{
    color: #f56c6c;
  }
  .el-icon-success{
    color: #67c23a;
  }
  .el-icon-circle-check{
    color: #67c23a;
  }
  .el-icon-info{
    color: #409eff
  }
  .el-icon-warning{
    color: #e6a23c;
  }
  .el-icon-warning-outline{
    color: #e6a23c;
  }

  p{
    display: inline-block;
    font-size: 14px;
    line-height: 28px;
    color: #333;
  }
}
// .center_main{
//   width: 100%;
//   height:100%;
//   margin: 0 auto;
//   line-height: 32px;
//   margin-top: 20px; 
// }
.center_main {
  width: 100%;
  left:0;
  margin: 0 auto;
  line-height: 36px;
  // margin-top: 20px;
  padding: 15px;
  overflow-y: auto;
  // height:410px;
  div{
    cursor:pointer;
    transition: all .4s;
    font-size: 14px;
    line-height: 36px;
    border-bottom: 1px solid #eee;
  }
  div:hover{
    color: #17a2b8;
  }
  .cur{
    color: #17a2b8
  }
}
.top_search{
  width: 100%;
  z-index: 99 !important;
}
.curs{
  color: #17a2b8 !important;
}
</style>